import { IScope } from "angular";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../shared/components/views/machines/detail/tabs";
import { Machine } from "../models/machine";
import { MachineConfiguration } from "../models/machineConfiguration";
import { IReportGroup } from "../../../reporting/interfaces/IReportGroup";
import { vsName as partTransactionComponentName } from "../../../parts/Pages/detail/partTransaction";
import { MachineDetailConfigurationViewArgs } from "../../shared/components/views/machines/detail/views/configurations/controller";
import { getChangeJournalViewStateDefinition } from "../../../records/changeJournal/changeJournalViewComponent/registration";
import { ChangeJournalObject } from "../../../records/changeJournal/changeJournalViewComponent/models";
import {
  machineObjectName,
  machineConfigurationObjectName,
} from "../../shared/names";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { Record } from "../../../records/server/crud";
export function machineDetailTabComponentConfigure(
  machineDetailTabsProvider: MachineDetailTabsProvider,
) {
  machineDetailTabsProvider
    .addElement({
      displayName: "Configurations",
      id: "configurations",
      uiSrefFragment: "configurations",
      requiredPermission: "machineView",
      children: [],
      stateDefinition: {
        url: "/configurations",
        template: require("!html-loader!./configurations.html").default,
        controller: [
          "$scope",
          "machine",
          "reportGroup",
          ($scope: IScope, machine: Machine, reportGroup: IReportGroup) => {
            const s = <any>$scope;
            s.machine = machine;
            s.reportGroup = reportGroup;
            s.editSref = "^.edit";
            s.accordionHeading = (args: MachineDetailConfigurationViewArgs) => {
              const machineConfiguration = <MachineConfiguration>(
                args.machineConfiguration
              );
              const { changeIsPending, dateString, currentConfiguration } =
                args;

              return `${machineConfiguration.ChangeType} - ${dateString}${
                currentConfiguration && !changeIsPending ? " - Current" : ""
              }${changeIsPending ? " - Pending" : ""}`;
            };
          },
        ],
      },
    })
    .addElement({
      displayName: "Part Transactions",
      id: "parts",
      uiSrefFragment: "parts",
      requiredPermission: "machineView",
      stateDefinition: {
        url: "/parts",
        component: partTransactionComponentName,
        resolve: {
          partTransaction: [
            ServerUtilityName,
            "machine",
            (serverUtility: ServerUtility, machine: Record) =>
              serverUtility.query({
                url: "/api/parts/partTransaction",
                query: {
                  ContextPath: "MachineId",
                  ContextValue: machine.Id,
                },
              }),
          ],
        },
      },
    })
    .addElement({
      displayName: "Change Log",
      id: "changeLog",
      uiSrefFragment: "changeLog",
      requiredPermission: "machineView",
      stateDefinition: getChangeJournalViewStateDefinition({
        //TODO - this needs to resolve the machine object and all configuration objects.  Currently only changes to
        //to the current configuration are showing
        resolveObjects: [
          "machine", // we’re already in main.machines.detail
          (machine: Machine): Promise<ChangeJournalObject[]> => {
            return Promise.resolve([
              {
                id: {
                  ObjectId: machine.Id,
                  ObjectName: machineObjectName, // 👈 important: target the right object
                },
                object: machine, // can pass full object or {}
              },
              ...(machine.Configs ?? []).map((c) => ({
                id: {
                  ObjectId: c.Id,
                  ObjectName: machineConfigurationObjectName,
                },
                object: c,
              })),
            ]);
          },
        ],
      }),
    });
}
machineDetailTabComponentConfigure.$inject = [MachineDetailTabsProviderName];
